import Swiper, { Autoplay, Navigation, Pagination, FreeMode } from "swiper";
/* eslint-disable */
("use strict");
Swiper.use([Autoplay]);

// Team cards carousel
const teamCardSwiper = new Swiper(".rlr-js-team-card-swiper", {
  // configure Swiper to use modules
  modules: [Navigation, Pagination],
  slidesPerView: 1,
  spaceBetween: 16,
  centeredSlides: false,
  slidesPerGroupSkip: 1,
  speed: 500,
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  loop: true,
  breakpoints: {
    1200: {
      allowTouchMove: false,
      spaceBetween: 32
    },
    1600: {
      slidesPerView: 1.2
    }
  },
  // Navigation arrows
  navigation: {
    nextEl: ".button--next",
    prevEl: ".button--previous"
  }
});

// Dynamic Filter Swiper
const dynamicFilterSwiper = new Swiper(".rlr-js-dynamic-filter-swiper", {
  modules: [Navigation, Pagination, FreeMode],
  direction: "horizontal",
  slidesPerView: "auto",
  slidesPerGroup: 3,
  spaceBetween: 16,
  freeMode: true,
  scrollbar: {
    el: ".swiper-scrollbar"
  },
  mousewheel: true,
  // Navigation arrows
  navigation: {
    nextEl: ".splide__arrow--next",
    prevEl: ".splide__arrow--prev"
  }
});

// Product card item multi-image carousel

const productMultiImageSwiper = new Swiper(".rlr-js-product-multi-image-swiper", {
  modules: [Navigation, Pagination, FreeMode],
  spaceBetween: 32,
  effect: "fade",
  preventClicks: false,
  navigation: {
    nextEl: ".splide__arrow--next",
    prevEl: ".splide__arrow--prev"
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  }
});
